import ApolloClient from "apollo-boost";

const isProducction = process.env.NODE_ENV === "production";
const uri = isProducction ? "https://tags.desigualdadessalud.org/prod/graphql" : "http://localhost:5000/graphql";

const client = new ApolloClient({
  uri
});

export default client;



// WEBPACK FOOTER //
// ./src/lib/apollo-tags.js